import { CompetitorComparisonLayout } from "@/components/marketing/CompetitorComparisonLayout";
import { COMPETITORS } from "@/lib/marketing-competitor-matrix";

export default function VsContentAgencyPage() {
  return <CompetitorComparisonLayout competitor={COMPETITORS["agence-redaction"]} />;
}
